//공장관리자 컬럼 정의
export const _plantManagerColumns = [
  {
    field: "psDate",
    headerName: "날짜",
    width: 130,
    valueFormatter: (params) => {
      const value = params.value;
      return value
        ? `${value.substring(0, 4)}.${value.substring(4, 6)}.${value.substring(
            6
          )}`
        : "";
    },
  },
  {
    field: "engId",
    headerName: "에너지종류",
    width: 130,
    valueFormatter: (params) => {
      const value = params.value;
      let engName = "";
      switch (value) {
        case "AIR":
          engName = "압축공기";
          break;
        case "STEAM":
          engName = "스팀";
          break;
        case "COOLWATER":
          engName = "냉수";
          break;
        case "EPWR":
           engName = "전기";    
           break;
        default:
          engName = value;
      }
      return engName;
    },
  },
  {
    field: "method",
    headerName: "사용/공급",
    width: 130,
    valueFormatter: (params) => {
      const value = params.value;
      let name = "";
      switch (value) {
        case "cons":
          name = "사용";
          break;
        case "prod":
          name = "공급";
          break;
        default:
          name = value;
      }
      return name;
    },
  },
  {
    field: "engUnit",
    headerName: "단위",
    width: 130,
  },
  {
    field: "complexInloName",
    headerName: "산업단지명",
    width: 130,
  },
  {
    field: "companyInloName",
    headerName: "회사명",
    width: 130,
    // valueGetter: getFullName,
  },
  {
    field: "plantInloName",
    headerName: "사업장명",
    width: 130,
  },
  {
    field: "sumAmt",
    headerName: "일간사용량",
    width: 130,
    valueFormatter: (params) => {
      return new Intl.NumberFormat("ko-KR").format(params.value);
    },
  },
];

//산단관리자 컬럼 정의
export const _complexManagerColumns = [
  {
    field: "psDate",
    headerName: "날짜",
    width: 120,
    valueFormatter: (params) => {
      const value = params.value;
      return value
        ? `${value.substring(0, 4)}.${value.substring(4, 6)}.${value.substring(
            6
          )}`
        : "";
    },
  },
  {
    field: "engId",
    headerName: "에너지종류",
    width: 120,
    valueFormatter: (params) => {
      const value = params.value;
      let engName = "";
      switch (value) {
        case "AIR":
          engName = "압축공기";
          break;
        case "STEAM":
          engName = "스팀";
          break;
        case "COOLWATER":
          engName = "냉수";
          break;
        default:
          engName = value;
      }
      return engName;
    },
  },
  {
    field: "method",
    headerName: "사용/공급",
    width: 100,
    valueFormatter: (params) => {
      const value = params.value;
      let name = "";
      switch (value) {
        case "cons":
          name = "사용";
          break;
        case "prod":
          name = "공급";
          break;
        default:
          name = value;
      }
      return name;
    },
  },
  { field: "engUnit", headerName: "단위", width: 100 },
  { field: "complexInloName", headerName: "산업단지명", width: 120 },
  // column 자체에 산단에 해당하는 공장 리스트 추가하기
  {
    field: "sumAmt",
    headerName: "합계",
    width: 120,
    valueFormatter: (params) => {
      // return new Intl.NumberFormat("ko-KR").format(params.value);
      return new Intl.NumberFormat("ko-KR").format(Math.round(params.value));
    },
  },
  // 해당 산단에 해당하는 공장들의 일자별 합계
];

export const managerColumns = (columns) => {
  return columns.map((column) => ({
    ...column,
    headerClassName: "DataGridHeader",
  }));
};

export const plantColumns = managerColumns(_plantManagerColumns);
export const complexColumns = managerColumns(_complexManagerColumns);

/**
 * @description 오늘 날짜에 대하여 해당 월의 1일과의 날짜 차이 구하기
 * @author seoeunPark
 * @date 15/12/2023
 * @param {*}
 * @return 오늘이 3일 이면 return 값은 2
 */
export const untilFirstDay = () => {
  // 현재 날짜 객체를 생성합니다.
  const currentDate = new Date();

  // 현재 달의 첫 번째 날(1일)을 설정합니다.
  const firstDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );

  // 오늘 날짜에서 첫 번째 날짜를 뺍니다.
  const daysUntilFirstDay = Math.floor(
    (currentDate - firstDayOfMonth) / (1000 * 60 * 60 * 24)
  );

  return daysUntilFirstDay;
};




